import './details';
import './lauferstellen';
import { dbh_helper } from '../src/dbh_helper';
import { dbh_ajax } from "Ressources/dbh_ajax";

if (dbh_helper.getUrlArea() == "abrechnungen" && dbh_helper.getUrlController() == "gutschriften") {
    $(document).ready(function () {
        $("#btnDruckansicht").on("click", function () {
            let form = dbh_helper.findNearestForm(this);

            new dbh_ajax().sendPostRequest({
                csrfToken: form != null && form != undefined ? $('input[name="__RequestVerificationToken"]', $(form)).val()?.toString() : '',
                actionName: "Suchen",
                responseType: 'arraybuffer',
                controllerName: "Abrechnungen/Gutschriften",
                parameter: dbh_helper.getParameterStringForForm(form) + "&druckansicht=druckansicht",
                callbackSuccess: (ajaxResult: any) => {
                    var file = new Blob([ajaxResult], { type: 'application/pdf' });
                    var fileURL = URL.createObjectURL(file);
                    window.open(fileURL);
                },
                callbackError: (ajaxResult: object) => {
                    console.log(ajaxResult);
                }
            });
        });
        $("#btnDruckansichtMeineGutschriften").on("click", function () {
            let form = dbh_helper.findNearestForm(this);

            new dbh_ajax().sendPostRequest({
                csrfToken: form != null && form != undefined ? $('input[name="__RequestVerificationToken"]', $(form)).val()?.toString() : '',
                actionName: "MeineGutschriftenSuchen",
                responseType: 'arraybuffer',
                controllerName: "Abrechnungen/Gutschriften",
                parameter: dbh_helper.getParameterStringForForm(form) + "&druckansicht=druckansicht",
                callbackSuccess: (ajaxResult: any) => {
                    var file = new Blob([ajaxResult], { type: 'application/pdf' });
                    var fileURL = URL.createObjectURL(file);
                    window.open(fileURL);
                },
                callbackError: (ajaxResult: object) => {
                    console.log(ajaxResult);
                }
            });
        });
        $("#btnXlsDownload").on("click", function () {
            window.open("/Abrechnungen/Gutschriften/Download?" + dbh_helper.getParameterStringForForm(dbh_helper.findNearestForm(this)) + "&xlsDownload=xlsDownload");
        });
    });
}
if (dbh_helper.getUrlArea() == "abrechnungen" && dbh_helper.getUrlController() == "rechnungen") {
    $(document).ready(function () {

        $("#btnExportAussenstaende").on("click", function () {
            window.open("/Abrechnungen/Rechnungen/DownloadAussenstaende");
        });

        $("#btnDruckansicht").on("click", function () {
            let form = dbh_helper.findNearestForm(this);

            new dbh_ajax().sendPostRequest({
                csrfToken: form != null && form != undefined ? $('input[name="__RequestVerificationToken"]', $(form)).val()?.toString() : '',
                actionName: "Suchen",
                responseType: 'arraybuffer',
                controllerName: "Abrechnungen/Rechnungen",
                parameter: dbh_helper.getParameterStringForForm(form) + "&druckansicht=druckansicht",
                callbackSuccess: (ajaxResult: any) => {
                    var file = new Blob([ajaxResult], { type: 'application/pdf' });
                    var fileURL = URL.createObjectURL(file);
                    window.open(fileURL);
                },
                callbackError: (ajaxResult: object) => {
                    console.log(ajaxResult);
                }
            });
        });
    });
}